export const BRAND = {
  name: "Gravityinc Business Solutions",
  short: "Gravityinc",
  logoUrl:
    "images/55qn89v1_gravity logo.png",
  phone1: "9995989843",
  phone2: "8089583843",
  whatsapp: "919995989843",
  gst: "32AMGPV4765P1Z9",
  address:
    "Door No. 39/5678, Ground Floor, Thekkanath Building, Near South Over Bridge, Panampilly Nagar, Kochi – 682036",
  city: "Kochi, Kerala, India",
};

export const WHATSAPP_LINK = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
  "Hi, I'd like to know more about DigiPOS for my business."
)}`;

export const ASSETS = {
  home:"/images/digiHero.png",
  zen: "/images/Digipos Zen.png",
  primex:
    "/images/primex new.jpeg",
  ongo: "/hero/ongo (1).png",
  insights:
    "/hero/insights1.png",
  zento:
    "/hero/zento (3).png",
  hardware:
    "/images/new-hero.jpeg"
};

export const HARDWARE_IMG = {
  touchPos:
    "/images/touchPos.png",
  barcodeScanner:
    "/images/barcode.png",
  labelPrinter:
    "/images/labelPrinter.png",
  androidPos:
    "/images/androidPos.png",
  cashDrawer:
    "/images/cash.png",
  barcodeLabels:
    "/images/br_label-removebg-preview.png",
  ribbonRoll:
    "/images/ribbon_roll-removebg-preview.png",
  thermalRoll:
    "/images/paper_roll-removebg-preview.png",
  Rfid:"/images/rfid.png",

  cables:"/images/accessories-removebg-preview.png",
  MobilePrinter:"/images/mobile.png",
  ThermalPrinter:"/images/thermal.png",
  Kiosk:"/images/kiosk-removebg-preview.png",


};

export const PRODUCTS = [
  {
    slug: "zen",
    name: "DigiPOS Zen",
    tag: "Complete Retail & Distribution ERP",
    oneLiner: "Offline + Online ERP for retailers, wholesalers & distributors.",
    accent: "#1565C0",
    bullets: [
      "Multi-branch & multi-counter billing",
      "GST, E-Invoice, E-Way Bill ready",
      "Tally integration + WhatsApp billing",
      "Works offline, syncs to cloud",
    ],
    platforms: ["Windows", "Cloud / Static IP", "Offline + Online"],
    image: ASSETS.zen,
  },
  {
    slug: "primex",
    name: "DigiPOS Primex",
    tag: "Android Billing for SMEs",
    oneLiner: "Android billing + web dashboard for SME retailers.",
    accent: "#00B4D8",
    bullets: [
      "Android billing application",
      "Web-based management portal",
      "Real-time cloud sync",
      "GST-compliant invoicing",
    ],
    platforms: ["Android App", "Web Dashboard", "Cloud Synced"],
    image: ASSETS.primex,
  },
  {
    slug: "insight",
    name: "DigiPOS Insight",
    tag: "Owner Dashboard & Monitoring",
    oneLiner: "Real-time business monitoring for owners, from anywhere.",
    accent: "#7C3AED",
    bullets: [
      "Live sales & collection tracking",
      "Stock & inventory alerts",
      "Customer / supplier ledgers",
      "User activity & audit logs",
    ],
    platforms: ["Android", "iOS", "For Zen Users"],
    image: ASSETS.insights,
  },
  {
    slug: "ongo",
    name: "DigiPOS Ongo",
    tag: "Van Sales & Distribution",
    oneLiner: "Van sales & field distribution management.",
    accent: "#059669",
    bullets: [
      "Warehouse → vehicle stock transfer",
      "On-the-go billing at customer location",
      "Route & salesman tracking",
      "Auto-sync with DigiPOS Zen",
    ],
    platforms: ["Android", "Integrates with Zen"],
    image: ASSETS.ongo,
  },
  {
    slug: "zento",
    name: "DigiPOS Zento",
    tag: "Delivery Management Platform",
    oneLiner: "Smart delivery tracking & management.",
    accent: "#F77F00",
    bullets: [
      "Delivery allocation & assignment",
      "Live status: picked-up, OFD, delivered",
      "Integrates with Zen & Primex",
      "Faster fulfillment, fewer errors",
    ],
    platforms: ["Android", "Integrates with Zen & Primex"],
    image: ASSETS.ongo,
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "DigiPOS", to: "/digipos", mega: true },
  { label: "Hardware", to: "/hardware" },
];
